import { useTheme } from "@emotion/react";
import React from "react";

const OtherMelodicsIcon = () => {
  const theme = useTheme();
  return (
    <svg
      width="34"
      height="38"
      viewBox="0 0 34 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_6_1930)">
        <path
          d="M30.5271 28.0237L25.9948 32.2918L27.1032 33.4689L31.6356 29.2009L30.5271 28.0237Z"
          fill="#282827"
        />
        <path
          d="M31.2437 33.1548C35.0077 29.5078 34.6125 25.3325 31.8767 22.51C29.1429 19.6875 26.8043 21.0382 25.4374 19.627C24.0705 18.2157 24.5403 17.7601 23.629 16.8186C21.9516 15.0868 19.7138 15.9618 18.2299 16.8952L21.2702 20.0342C22.254 19.9133 23.2802 20.2278 24.0241 20.9939C25.2822 22.2943 25.2499 24.3668 23.9495 25.6248C22.6512 26.8828 20.5767 26.8506 19.3186 25.5502C18.5767 24.7821 18.2945 23.7479 18.4477 22.768L15.4074 19.629C14.4256 21.0806 13.4801 23.2902 15.1575 25.022C16.0687 25.9635 16.5405 25.5079 17.9074 26.9191C19.2743 28.3304 17.8489 30.6247 20.5827 33.4472C23.3165 36.2717 27.4777 36.7999 31.2437 33.1548ZM26.6269 32.1549L30.3909 28.5098L31.3022 29.4513L27.5382 33.0964L26.6269 32.1549Z"
          fill="white"
        />
        <path
          d="M5.31152 3.5521L2.48737 6.28699L6.58829 10.5218L9.41244 7.78689L5.31152 3.5521Z"
          fill="white"
        />
        <path
          d="M1.56111 6.27082L0.619568 7.18228L1.98676 8.5946L2.92831 7.68313L1.56111 6.27082Z"
          fill="#282827"
        />
        <path
          d="M3.38477 8.15391L2.44354 9.0657L3.81123 10.4775L4.75246 9.56575L3.38477 8.15391Z"
          fill="#282827"
        />
        <path
          d="M5.20719 10.0364L4.26581 10.948L5.63325 12.3601L6.57463 11.4484L5.20719 10.0364Z"
          fill="#282827"
        />
        <path
          d="M6.26715 1.71446L5.32593 2.62625L6.69362 4.03809L7.63484 3.1263L6.26715 1.71446Z"
          fill="#282827"
        />
        <path
          d="M8.08939 3.59701L7.14801 4.50864L8.51545 5.92071L9.45684 5.00909L8.08939 3.59701Z"
          fill="#282827"
        />
        <path
          d="M9.91227 5.47817L8.97089 6.3898L10.3383 7.80188L11.2797 6.89025L9.91227 5.47817Z"
          fill="#282827"
        />
        <path
          d="M21.6855 20.5987C21.4476 20.5987 21.2198 20.635 21.002 20.6955L20.5283 20.2076L17.6796 17.2662L9.39754 8.71399L7.51453 10.5365L15.7966 19.0887L18.6453 22.0301L19.1432 22.5442C19.0787 22.7741 19.0444 23.016 19.0444 23.266C19.0525 24.7317 20.246 25.9131 21.7117 25.905C23.1774 25.897 24.3588 24.7035 24.3507 23.2378C24.3427 21.7721 23.1492 20.5907 21.6835 20.5987H21.6855Z"
          fill="#282827"
        />
      </g>
      <defs>
        <clipPath id="clip0_6_1930">
          <rect
            width="33.3801"
            height="34.0132"
            fill="white"
            transform="translate(0.619568 1.7142)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default OtherMelodicsIcon;
